import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import ApproveThreeElement from "./dynamic-report/ApproveThreeElement";
import ApproveThreeForm from "./dynamic-form/ApproveThreeForm";

class ReportApproveThree extends Component {
  // ----------------------
  // Computed
  // ----------------------

  get showReviewed() {
    return this.props.report.approvedThreeAt;
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        {this.props.report.getCanApproveThree(this.props.userContext.scope) &&
        <ApproveThreeForm reportGuid={this.props.report.guid}/>
        }
        {this.showReviewed &&
        <ApproveThreeElement
          approvedThreeAt={this.props.report.approvedThreeAt}
          approvedThreeBy={this.props.report.getFullNameFor('approverThree')}
          approveCommentThree={this.props.report.approveCommentThree}
        />
        }
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps, null)(ReportApproveThree);
